import { cn } from '@tempo-io/sui-class-utils';
import type { ComponentProps } from 'react';

export const IconContainer = ({ className, ...props }: ComponentProps<'span'>) => (
  <span
    className={cn(
      'inline-flex size-[1.1em] shrink-0 select-none items-center justify-center text-[1.5rem]',
      className,
    )}
    {...props}
  />
);

export default IconContainer;
